import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { Kasa, KasaClient, TaxesSettlements, TaxesSettlementsDetails, TaxSettlementClient} from "src/app/web-api-client";
import { WtStorageService } from "../../wt-storage.service"; 
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DateHelper } from "src/app/shared/helpers/date.helper";
import { forkJoin } from "rxjs";
import { SettlementdetailsComponent } from "./settlement-details/settlement-details.component";
import { CreateTaxSettlementComponent } from "../create-tax-settlement/create-tax-settlement.component";


@Component({
  selector: 'app-tax-settlement',
  templateUrl: './tax-settlement.component.html',
  styleUrls: ['./tax-settlement.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush
})
export class TaxSettlementComponent implements OnInit {

  public isLoaded: boolean = false; 
  selectedService: TaxesSettlements;
  public services: TaxesSettlementsDetails[];
  public taxSettlement: TaxesSettlements[] = [];
  


  constructor(private readonly changeDetectionRef:ChangeDetectorRef,public readonly localCache:WtStorageService, private readonly modalService: NgbModal,public client:TaxSettlementClient){

  }

  ngOnInit(): void {

    this.LoadData();

  }


  private LoadData() {
    this.isLoaded = false;
    forkJoin([this.client.getList(), this.client.getTaxSettlementList()])
      .subscribe((([allServices, settlements]) => {
        this.services = allServices;
        this.taxSettlement = settlements;
          this.isLoaded = true;
        this.changeDetectionRef.detectChanges();

      }));
       
    }

  public onSelected(service: TaxesSettlementsDetails){
   if (this.isSelected(service)){
    this.selectedService = null;
  }
  else{

     this.selectedService = service;
  }
 }

  public isSelected(service: TaxesSettlementsDetails):boolean{
   return this.selectedService == service;
 }
 
  public getStatus(item: TaxesSettlements) {

    switch (item.status) {
      case 0:
        return 'Необработен';
      case 1:
        return 'В Обработка';
      case 2:
        return 'Обработен';
    }
    return 'Няма информация';
  }


  public getIBAN(item: TaxesSettlements) {

    return this.services.find(d => d.idreff == item.idreff).iban;
  }

  public getDate(item: Date): string {
       if (item.getFullYear().toString() == '0001' || item.getFullYear().toString() =='1') {
      return '';
    }

    return DateHelper.GetFormattedDate(item);
  }

  public checkDetails() {
    const modalRef = this.modalService.open(SettlementdetailsComponent, { size: 'xl', centered: true, backdrop: 'static' });
    modalRef.componentInstance.settlementDetails = this.services.filter(d=>d.idreff == this.selectedService.idreff);
    modalRef.componentInstance.settlement = this.selectedService;
  }

   
}

